<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 account_section">
    <div class="my-account-title">Forecasting Information</div>
    <div class="account_login_info">
      <div class="row">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
          <label class="account_label" v-if="FormInputs.IndividualLabels">Pledged number of orders this year</label>
          <label class="account_label" v-else>Location's pledged number of orders this year</label>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
          <p v-if="FormInputs.BusinessLabels || FormInputs.NonProfitLabels"></p>
          <p class="account_p" v-if="AccountView.primaryContact.officeLocation.numberOfJobs || AccountView.primaryContact.officeLocation.numberOfJobs == '0'">{{AccountView.primaryContact.officeLocation.numberOfJobs + " " +orderDesc}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label class="account_label">How do you plan on serving those patients?</label>
          <br/>
          <ul>
            <li v-for="service in forecastServices">
              {{ service }}
            </li>
          </ul>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
          <ul></ul>
        </div>
      </div>
      <div class="row" v-show="AccountView.primaryContact.officeLocation.numberOfJobs >= 100">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
          <label class="account_label">Monthly Breakdown</label>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
            <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-3 col-xs-3">
                    <table class="forecasting_services">
                        <tr>
                            <td>Jan</td>
                            <td>{{AccountView.primaryContact.officeLocation.jobs.january}}</td>
                        </tr>
                        <tr>
                            <td>Feb</td>
                            <td>{{AccountView.primaryContact.officeLocation.jobs.february}}</td>
                        </tr>
                        <tr>
                            <td>Mar</td>
                            <td>{{AccountView.primaryContact.officeLocation.jobs.march}}</td>
                        </tr>
                        <tr>
                            <td>Apr</td>
                            <td>{{AccountView.primaryContact.officeLocation.jobs.april}}</td>
                        </tr>
                        <tr>
                            <td>May</td>
                            <td>{{AccountView.primaryContact.officeLocation.jobs.may}}</td>
                        </tr>
                        <tr>
                            <td>Jun</td>
                            <td>{{AccountView.primaryContact.officeLocation.jobs.june}}</td>
                        </tr>
                    </table>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-3 col-xs-3">
                    <table class="forecasting_services">
                        <tr>
                            <td>Jul</td>
                            <td>{{AccountView.primaryContact.officeLocation.jobs.july}}</td>
                        </tr>
                        <tr>
                            <td>Aug</td>
                            <td>{{AccountView.primaryContact.officeLocation.jobs.august}}</td>
                        </tr>
                        <tr>
                            <td>Sept</td>
                            <td>{{AccountView.primaryContact.officeLocation.jobs.september}}</td>
                        </tr>
                        <tr>
                            <td>Oct</td>
                            <td>{{AccountView.primaryContact.officeLocation.jobs.october}}</td>
                        </tr>
                        <tr>
                            <td>Nov</td>
                            <td>{{AccountView.primaryContact.officeLocation.jobs.november}}</td>
                        </tr>
                        <tr>
                            <td>Dec</td>
                            <td>{{AccountView.primaryContact.officeLocation.jobs.december}}</td>
                        </tr>
                    </table>
                </div>
            </div>
          <p class="account_p"></p>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-font-size-17" v-on:click="EditSection()">Edit</button>
      </div>
    </div>

    <loading-component v-if="isLoading"></loading-component>
    <div v-if="isModalShown">
        <div class="modal-mask" role="dialog">
          <div class="overlay-mask">
            <div class="modal-dialog modal-lg">
                <div class="modal-content modal-edit-bg">
                    <div class="modal-body">
                        <div v-if="isFormLoading" class="row">
                            <page-loader></page-loader>
                        </div>
                        <div v-else>
                            <div class="close_btn" v-on:click="CloseModal()"></div><br>
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <edit-forecasting-info :AccountEdit="AccountEdit" :ForcastServices="forecastServices" @setUpdatedServices="SetUpdatedServices" :FormInputs="FormInputs" :OfficeLocationValidationResult="OfficeLocationValidationResult"></edit-forecasting-info>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                                    <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17" v-on:click="SaveAccount()">Save</button>
                                    <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17" v-on:click="CloseModal()">Cancel</button>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import EditForecastingInfo from "@/components/portal/userAccount/accountEdit/EditForecastingInfo";
import LoadingComponent from "@/components/shared/LoadingComponent";
import PageLoader from "@/components/shared/PageLoader";
export default {
   props: ['AccountView', 'AccountEdit', 'FormInputs', 'isFormLoading'],
   components: { EditForecastingInfo, LoadingComponent, PageLoader },
   data(){
    return{
      isModalShown: false,
      OfficeLocationValidationResult: {},
      isLoading: false,
      orderDesc: "",
      forecastServices: [], // read only
    }
  },
  methods: {
    EditSection() {
      document.body.classList.add("body-overflow");
      this.OfficeLocationValidationResult= {};
      this.isModalShown = !this.isModalShown;
      this.$emit("load");
      this.$emit("clicked");
    },
    CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    },
    SetUpdatedServices(services) {
      this.AccountEdit.primaryContact.officeLocation.howDoYouPlanOnServingThosePatient = services;
    },
    SaveAccount() {
      this.isLoading = true;
      this.OfficeLocationValidationResult = {};
      var numberOfJobs =this.AccountEdit.primaryContact.officeLocation.numberOfJobs;
      if (numberOfJobs < 100){
          this.AccountEdit.primaryContact.officeLocation.jobs = {
              january: null,
              february: null,
              march: null,
              april: null,
              may: null,
              june: null,
              july: null,
              august: null,
              september: null,
              october: null,
              november: null,
              december: null
          }
        }
        var totalOfJobs = this.SaveTotalJobs(this.AccountEdit.primaryContact.officeLocation.jobs);
        if(numberOfJobs < totalOfJobs){
            this.AccountEdit.primaryContact.officeLocation.numberOfJobs = totalOfJobs;
        }

        //const p2 = axios.post('/Account/UpdateForecasting', this.AccountEdit);

        axios.post("/Account/ForecastingInformation", this.AccountEdit.primaryContact.officeLocation, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        }).then((res) => {
          this.isLoading = false;
          if (res.data.isSuccess == true) {
            const forcastingResp = res.request.responseURL.indexOf('ForecastingInformation') !== -1
            if (forcastingResp) {
              this.forecastServices = res.data.raw.howDoYouPlanOnServingThosePatient;
            }
            this.$emit("selfReload");
            this.CloseModal();
            this.$emit("success");
          } else {
            this.OfficeLocationValidationResult = res.data.raw.validationResult;
            console.log("Error in Saving!");
          }
        }).catch(error => {
          console.log(error);
          this.$router.push({name: 'Error'});
        });
        // axios.post("/Account/ForecastingInformation", this.AccountEdit.primaryContact.officeLocation, {
        //   headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        // })
        // .then(response => {
        //   var _this = this;
        //   _this.isLoading = false;
        //   if (response.data.isSuccess == true) {
        //     // _this.CheckNumberofJobs();
        //     _this.$emit("selfReload");
        //     _this.CloseModal();
        //     _this.$emit("success");
        //   } else {
        //     _this.OfficeLocationValidationResult = response.data.raw.validationResult;
        //     console.log("Error in Saving!");
        //   }
        // })
        // .catch(function(error) {
        //   console.log(error);
        //   _this.$router.push({name: 'Error'});
        // });
    },
    SaveTotalJobs(job) {
        return (
                (job.january ? parseInt(job.january) : 0) +
                (job.february ? parseInt(job.february) : 0) +
                (job.march ? parseInt(job.march) : 0) +
                (job.april ? parseInt(job.april) : 0) +
                (job.may ? parseInt(job.may) : 0) +
                (job.june ? parseInt(job.june) : 0) +
                (job.july ? parseInt(job.july) : 0) +
                (job.august ? parseInt(job.august) : 0) +
                (job.september ? parseInt(job.september) : 0) +
                (job.october ? parseInt(job.october) : 0) +
                (job.november ? parseInt(job.november) : 0) +
                (job.december ? parseInt(job.december) : 0)
              );
    },
    CheckNumberofJobs() {
        var numberOfJobs = this.AccountEdit.primaryContact.officeLocation.numberOfJobs;
        if(numberOfJobs == 1) {
            this.orderDesc = 'order';
            return this.orderDesc;
        }
        else
        {
            this.orderDesc = 'orders';
            return this.orderDesc;
        }

    },

    getForecastServicesToPatients() {
      axios.get(`/Account/Forecasting/${this.AccountEdit.salesforceId}`, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(res => {
        this.forecastServices = res.data.raw;
      });
    },
  },

  created() {
    this.CheckNumberofJobs();
    this.getForecastServicesToPatients();
  }
}
</script>



// WEBPACK FOOTER //
// ForecastingInfo.vue?ff70323e